import React, {Component} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../request'
import styles from '../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import {RightsWrapper} from '../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()
class LoyalitySettings extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    universities:[],
    allUsers:[],
    percentage:false,
    fixed:false
  }

  apiRequest = params => {
    return new Promise(async resolve => {
        let response = await Request.getProgramDetails(params)
        this.setState({total: response.total})
        resolve(response)
    })
  }

  getAllBoardCategories = async()=>{
    let response = await Request.getBoardCategoryDetails({
        results:1000,
        count:1000,
    })
    return response
  }

  handleSubmit = e => {
    const {form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateProgramDetail(values)
        } else {
            x = await Request.addProgramDetail(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab:'0'
          })
          notification.success({
            message: this.state.id
              ? `Program Details Updated Successfully`
              : 'Program Details Added successfully'
          })
          if (!this.state.id) {
            form.setFieldsValue({
                referralType:'',
                referralPaymentType:"",
                percentage:"",
                credits:''
            })
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }

  deleteProgramDetail = async data =>{
    this.setState({loading:true})
    await Request.deleteProgramDetail(data)
    this.setState({loading:false})
    this.table.current.reload();
    notification.success({
        message: 'Deleted Successfully',
        duration: 20,
        key: `${data._id}-close`
      })
  }

  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }

  setProgramDetailsData(programDetailId) {
    if(programDetailId) {
      Request.getProgramDetailById({id:programDetailId}).then(({doc,error,message})=>{
        if(!error && doc) {
          this.setState({
            id: doc._id,
            activeTab: '1'
        })
        if(doc.referralPaymentType === "Percentage") {
          this.setState({percentage:true, fixed:false})
        }else if (doc.referralPaymentType === "Fixed") {
          this.setState({percentage:false, fixed:true})
        }
        this.props.form.setFieldsValue({
          referralType:doc.referralType,
          referralPaymentType:doc.referralPaymentType,
          percentage:doc.percentage,
          credits:doc.credits
        })
        }else {
          notification.error({
            message: 'Error Getting Data',
            description: message
          })
        }
      })
    }
  }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  loadApis = async() =>{
    let universityParams = {
        results:10000,
        count:10000
    }
    let universityResponse = await Request.getUniversities(universityParams)
    let universities = []
    _.each(universityResponse.data, (university)=>{
        universities.push({id:university._id, display:university.universityInstitutionName})
    })
    let usersParams = {
        sortField:'_id',
        sortOrder:'ascend',
        results: 200,
        active:true,
        userType:{$ne : "Student"}
    }
    let userResponse = await Request.loadUser({...usersParams, regExFilters: ['name']})
    let allUsers = []
    _.each(userResponse.data, (user)=>{
        allUsers.push({id:user._id, display:user.name})
    })
    this.setState({universities, allUsers})
  }

  

  componentWillMount() {
    
  }

  async componentDidMount() {
    this.loadApis()
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }
  render() {
    const {
      form: {getFieldDecorator, setFieldsValue}
    } = this.props
    const {id, percentage, fixed} = this.state;

    const inputTypes = {
      fields: [
        {
          label:'Referral Type',
          key:'referralType',
          required:true,
          type:'select',
          options:["IELTS/PTE", "Visitor Visa", "Study Abroad"],
          onChange:v=>{
            this.props.form.setFieldsValue({referralType:v})
          }
        },
        {
          label:'Payment Type',
          key:'referralPaymentType',
          required:true,
          type:'select',
          options:["Percentage", "Fixed"],
          onChange:v=>{
            if(v === "Percentage") {
              this.setState({percentage:true, fixed:false})
            }else if (v === "Fixed") {
              this.setState({percentage:false, fixed:true})
            }
            this.props.form.setFieldsValue({referralPaymentType:v})
          }
        },
        {
          label:'Credits',
          key:'credits',
          required:fixed,
          type:'number',
          hidden:!fixed
        },
        {
          label:'Percentage',
          key:'percentage',
          required:percentage,
          type:'number',
          hidden:!percentage
        },
      ]
    };

    const columns = [
      {
        title:'Referral Type',
        key:'referralType',
      },
      {
        title:'Credits / Percentange',
        key:'credits',
        render:(text,record) => (
          <div>{record.credits?record.credits:`${record.percentage}%`}</div>
        )
      },
      {
        title: 'Added By',
        key: 'createdByName',
        dataIndex: 'createdByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'loyalityProgramDetails.edit'}>
              <Tooltip title="Edit Program Detail">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setProgramDetailsData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'loyalityProgramDetails.delete'}>
              <Tooltip title="Delete Program Detail">
                <Popconfirm
                  title="Are you sure delete this Program Detail?"
                  onConfirm={() => {
                    this.deleteProgramDetail({_id: record._id})
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Program Details `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Details`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            
            <TabPane tab={(id?'Edit':'Add') + ' Detail '} key={1}>
              <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{marginBottom: 10, marginLeft: '1%'}}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default LoyalitySettings
